<div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="space-around stretch" fxFlex>
  <div fxFlex="66" fxLayout="column" fxLayoutAlign="space-around stretch" data-qa="messages">
    @if (hasInvalidNetzzuordnungen) {
      <span>Eine oder mehrere Netzzuordnungen sind ungültig geworden.</span>
      <span>Bitte prüfen Sie Ihre Daten.</span>
    }
    @if (!hasInvalidNetzzuordnungen) {
      <span>Es gibt keine Änderungen bei den Netzzuordnungen.</span>
      <span>In diesem Fall ist keine Aktivität notwendig.</span>
    }
  </div>
  <div fxFlex="33" fxLayoutAlign="center center" data-qa="link">
    <a [matButton]="hasInvalidNetzzuordnungen ? 'filled' : 'outlined'"
      [routerLink]="routerLink"
      [queryParams]="queryParams">
      Erzeugungsanlagen
    </a>
  </div>
</div>
